import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './RssNewsGrid.css';

function RssNewsGrid() {
  const [rssData, setRssData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setError(null);
      try {
        // API בשרת – מחזיר מערך חדשות
        const response = await axios.get(
       // 'http://localhost:3000/api/rss?limit=6'
       'https://startpoint.es/node?limit=6'
        );
       
        const data = response.data;
        setRssData(Array.isArray(data) ? data : []);
       
      } catch (err) {
        setError(err);
        setRssData([]);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);
   
  // רשימת קטגוריות ייחודיות
  const categories = [...new Set(rssData.map(item => item.category))];

  // סינון לפי קטגוריה
  const filteredData = selectedCategory
    ? rssData.filter(item => item.category === selectedCategory)
    : rssData;

  return (
    <div className="rss-news-container">
      <div className="rss-categories-bar">
        <button
          className={`rss-category-btn${selectedCategory == null ? ' selected' : ''}`}
          onClick={() => setSelectedCategory(null)}
        >
          כל הנושאים
        </button>
        {categories.map(category => (
          <button
            key={category}
            className={`rss-category-btn${selectedCategory === category ? ' selected' : ''}`}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="rss-news-grid">
        {loading ? (
          <div>טוען חדשות...</div>
        ) : error ? (
          <div>שגיאה: {error.message}</div>
        ) : filteredData.length ? (
          filteredData.map((item, idx) => (
            <div key={idx} className="rss-news-card">
              {item.imageUrl && (
                <img src={item.imageUrl} alt="cover" className="rss-news-card-img" />
              )}
              <div className="rss-news-card-content">
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rss-news-card-title"
                >
                  {item.title}
                </a>
                <div className="rss-news-card-desc">{item.description}</div>
                <div className="rss-news-card-footer">
                  <span className="rss-news-card-source">{item.source}</span>
                  <span className="rss-news-card-date">
                    {item.pubDate
                      ? new Date(item.pubDate).toLocaleDateString()
                      : ''}
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div>לא נמצאו חדשות בנושא זה.</div>
        )}
      </div>
    </div>
  );
}

export default RssNewsGrid;
